import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { FiltroREPComponent } from "./filtro";
import * as globals from "app/resources/globals";
import { CancelarREP } from "./cancelacion";
import { DoctoEdit } from "./../../facturas/rep";
import { EnviarCorreoModalEdit } from "./../../facturas/correo"
export { RepDetalle } from "./edit";

type Entity = models.RepDTO;
import { columnas } from "./columns";
const resource = resources.Rep;
interface Props {
    permisos: models.Rol;
    filtro: models.FiltroRep;
    onFiltroChange: (x: models.FiltroRep) => void;
}

class REPListCompNoRx extends React.PureComponent<Props> {
    modalManager = kea.createModalManager();

    onVer = async (x: Entity) => history.go("./" + x.IdRegistro);

    onEliminar = async (x: Entity) => {
        if (await kea.yesno("Eliminar REP?", "" + x.SerieFolio)) {
            await resource.Delete(x.IdRegistro);
            await kea.message("el REP ha sido eliminada");
        }
    }

    onCancelar = async (x: Entity) => {
        if (x.EsTimbrada) {
            await kea.message("Advertencia", "Si cancela este REP debe de generar uno que lo sustituya ya que está timbrado", "warning");
        }
        var cancelada = await CancelarREP(x.IdRegistro, this.modalManager.showModal);
    }

    onTimbrar = async (x: Entity) => {
        if (await kea.yesno("¿Timbrar REP?", "" + x.SerieFolio)) {
            await resource.TimbrarREP(x.IdRegistro);
            await kea.message("EL REP ha sido timbrada");
        }
    }

    OnObtenerXML = async (x: Entity) => {
        if (await kea.yesno("¿Obtener XML del REP?", "" + x.SerieFolio)) {
            const comprobanteXML = await resource.ObtenerXML(x.IdRegistro);
            kea.download(kea.base64ToBlob(comprobanteXML, 'application/xml'), "Recibo electrónico de pago.xml");
        }
    }

    OnObtenerPDF = async (x: Entity) => {
        if (await kea.yesno("¿Obtener pdf del REP?", "" + x.SerieFolio)) {
            const facturaPDF = await resource.ObtenerPDF(x.IdRegistro);
            kea.download(kea.base64ToBlob(facturaPDF, 'application/pdf'), "Recibo electrónico de pago.pdf");
        }
    }

    EnviarCorreo = async (x: Entity) => {
        const correo = x.CorreoClienteFacturacion || "";
        x.SerieFolio
        const result = await this.modalManager.showModal(EnviarCorreoModalEdit, undefined, correo);
        if (result.result) {
            const enviado = await resource.EnviarCorreo(x.IdRegistro, result.value);
            if (enviado)
                await kea.message("Correo enviado");
            else
                await kea.message("Correo no enviado", "Revisar la configuración de cliente smtp ó la dirección correo de destino del rep", "error");
        }
    }

    onRegresar = () => history.go('../');
    
    private filtro = (props: Props) => props.filtro;
    private reps = createSelectorRx(this.filtro, filtro => observeResource(resource.Query, filtro));
    private importeTotal = createSelectorRx(this.reps, reps => reps.map(x => x.ImportePagado).reduce((a, b) => a + b, 0));

    componentWillMount = async() => {
        const result = await resources.Cobranza2.TieneCliente(this.props.permisos.IdRegistro);

        this.props.filtro.IdCliente = result.IdCliente
        this.props.onFiltroChange(this.props.filtro);
    }

    render() {
        const cols = columnas(this, this.props.permisos);
        const filtro = this.filtro(this.props);
        const reps = this.reps(this.props);
        const importeTotal = this.importeTotal(this.props);

        return (
            <div>
                <FiltroREPComponent value={filtro} onChange={this.props.onFiltroChange} /> 
                <kea.Grid2 columnas={cols} cookieKey={"REPListCookieKey"} items={reps} getKey={x => x.IdRegistro} />
                {this.modalManager.component}
            </div>
        )
    }
}

const REPListComp = componentToRx(REPListCompNoRx);

export class REPList extends React.PureComponent {
    render() {
        return (
            <REPListComp
                permisos={resources.User.PermisoRx}
                filtro={globals.state.map(x => x.filtroREP)}
                onFiltroChange={x => globals.setState({ filtroREP: x })}
            />
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/reps/index.tsx